import React, { useEffect } from 'react'
import moment from 'moment'

import { Box, Grid, Typography } from '@material-ui/core'

import useProfileContext from 'src/context/ProfileContext'
import { useQueryPaginator } from 'src/components/Table'
import { FreightShipment } from 'src/api/models'
import { Barcode } from 'src/components/Barcode'
import { skuit } from 'src/services/skuit'

interface PalletProps {
  shipment: FreightShipment
  index: number
  total: number
}

const PalletLabel = (props: PalletProps) => {
  const { shipment, index, total } = props
  const orderBarcode = shipment.order ? { barcode: shipment.order?.guid, type: 'datamatrix', displayName: '' } : null
  const shipmentBarcode = { barcode: shipment.guid, type: 'datamatrix', displayName: '' }
  const { profile } = useProfileContext()

  return (
    <div className="always-page-break">
      <Box className="print-page" pt={5}>
        <Grid container justify="center" alignItems="center" spacing={2}>
          <Grid item xs={2}>
            {orderBarcode && <Barcode barcode={orderBarcode} />}
          </Grid>
          <Grid item xs={10}>
            <Typography variant="h1">Order #{shipment.order?.number}</Typography>
          </Grid>
          <Grid item container xs={12} justify="center" alignItems="center">
            <Typography variant="h1">
              {index + 1} of {total}
            </Typography>
          </Grid>
          <Grid item container xs={10}>
            <Grid item xs={12}>
              <Typography variant="h1">Carrier: {shipment.carrier?.name}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h3">Tracking: {shipment.trackingNumber}</Typography>
            </Grid>
          </Grid>
          <Grid item xs={2}>
            <Barcode barcode={shipmentBarcode} />
          </Grid>
          <Grid item xs={12}>
            <Typography>Printed on {moment().format('lll')}</Typography>
          </Grid>
          {!!profile && (
            <Grid item xs={12}>
              <Typography>By {`${profile.fullName}`}</Typography>
            </Grid>
          )}
        </Grid>
      </Box>
    </div>
  )
}

interface Props {
  shipment: FreightShipment
  onReadyToPrint?: () => void
}

export const ShipmentPalletLabels = (props: Props) => {
  const { shipment, onReadyToPrint } = props
  const palletsPaginator = useQueryPaginator(
    'shipment-pallet-list',
    skuit.sc.freight.shipments.pallets.list,
    { params: { page_size: 200, shipments: shipment.guid } }
  )

  useEffect(() => {
    if (!palletsPaginator.loading) {
      onReadyToPrint?.()
    }
  }, [onReadyToPrint, palletsPaginator.loading])

  return (
    <>
      {palletsPaginator.data.results.map((pallet, index) => (
        <PalletLabel
          key={pallet.guid}
          shipment={shipment}
          index={index}
          total={palletsPaginator.data.count}
        />
      ))}
    </>
  )
}
